import { MediaContentDTO } from '@touche-lts/panel-ui/dist'

export const imgUrlToMediaContentDTO = (url: string): MediaContentDTO => {
  return {
    id: null,
    contentType: null,
    url,
    label: null,
    mainImage: null,
    originalHeight: null,
    originalWidth: null,
    portrait: null,
    portraitWidth: null,
    portraitX: null,
    portraitY: null,
    square: null,
    squareWidth: null,
    squareX: null,
    squareY: null,
    createdDate: null,
    backgroundImage: false
  }
}
